/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { businessModelGoToMarketDtoSchema } from "./businessModelGoToMarketDtoSchema.ts";
import { businessModelRevenueChannelDtoSchema } from "./businessModelRevenueChannelDtoSchema.ts";
import { businessModelTargetGroupDtoSchema } from "./businessModelTargetGroupDtoSchema.ts";
import { z } from "zod/v4";

export const businessModelSectionDtoSchema = z.object({
  summary: z.optional(z.string()),
  get targetGroups() {
    return z.array(businessModelTargetGroupDtoSchema).optional();
  },
  get revenueChannels() {
    return z.array(businessModelRevenueChannelDtoSchema).optional();
  },
  get goToMarket() {
    return z.array(businessModelGoToMarketDtoSchema).optional();
  },
});
